import { ApplicationStatus } from 'enums/ApplicationStatus';
import { DashboardLabelName } from 'enums/DashboardLabelName';

export const getCurrentLabel = (status?: ApplicationStatus) => {
  switch (status) {
    case ApplicationStatus.Active:
      return DashboardLabelName.NewInquiry;

    case ApplicationStatus.Pitched:
      return DashboardLabelName.Prequalified;

    case ApplicationStatus.Purgatory:
    case ApplicationStatus.Processing:
    case ApplicationStatus.Compliance:
    case ApplicationStatus.ReadyToSubmit:
      return DashboardLabelName.Processing;

    case ApplicationStatus.Underwriting:
    case ApplicationStatus.NeedMoreInfo:
    case ApplicationStatus.NMICompleted:
      return DashboardLabelName.Underwriting;

    case ApplicationStatus.PendingFunding:
      return DashboardLabelName.Approved;

    case ApplicationStatus.Approved:
      return DashboardLabelName.Funded;

    case ApplicationStatus.Rejected:
      return DashboardLabelName.Denied;

    default:
      return '';
  }
};

export const getCompleteInformationDueDateMessage = (dueDate: string | null): string => {
  if (!dueDate) {
    return '';
  }

  return `Submit All Required Information and Documents by ${dueDate}.`;
};
